export const TELEEXPERTISE_CREATE_REQUEST = "TELEEXPERTISE_CREATE_REQUEST"
export const TELEEXPERTISE_CREATE_SUCCESS = "TELEEXPERTISE_CREATE_SUCCESS"
